export const compareNumericCharacterIds = (a, b) => {
  const idA = parseInt(a, 10);
  const idB = parseInt(b, 10);
  const nA = Number.isFinite(idA) ? idA : Number.MAX_SAFE_INTEGER;
  const nB = Number.isFinite(idB) ? idB : Number.MAX_SAFE_INTEGER;
  return nA - nB;
};

export const sortIdsByNumericAsc = (ids) => [...(ids || [])].sort(compareNumericCharacterIds);
